<template>
  <div class="login-content">
    <div v-click-outside="onClickOutside" class="modal-login">
      <div class="item--title">
        <span class="item--title">
          An email will be sent to this email address.
        </span>
        <span class="item--close" @click="closeModal"
          ><font-awesome-icon
            class="item--close-icon"
            id="user--btn-icon"
            icon="times"
        /></span>
      </div>
      <div class="form-login" @keyup.enter="sendForgotPassword">
        <div class="area-input">
          <input
            class="item--input"
            v-model="form.email"
            placeholder="Email"
            type="text"
          />
          <font-awesome-icon class="input--icon" icon="envelope" />
        </div>
      </div>
      <div class="area-btn-login">
        <button class="item--btn btn-login" @click.prevent="sendForgotPassword">
          Send
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "IthMenuAsside",
  data: () => ({
    login: false,
    directives: {
      clickOutside: vClickOutside.directive
    },
    form: { email: "" },
    alert: { color: "", message: "" }
  }),
  computed: mapState(["menuAsside"]),
  methods: {
    onClickOutside(event) {
      if (event.target.className == "login-content") {
        this.$store.commit("DISABLED_MENU");
      } //this.menuAsside != true &&
    },
    closeModal() {
      this.$store.commit("toggleForgotModal");
      this.$store.commit("DISABLED_MENU");
    },
    async sendForgotPassword() {
      await this.$Parse.User.requestPasswordReset(this.form.email)
        .then(() => {
          this.alert.color = "#94C659";
          this.alert.message = "Email Sent";
          this.$store.commit("editAlert", this.alert);
          this.$store.commit("DISABLED_MENU");
        })
        .catch(response => {
          this.alert.color = "#EF3D58";
          this.alert.message = response.message;
          this.$store.commit("editAlert", this.alert);
        });
    }
  }
};
</script>

<style scoped>
.login-content {
  background-color: rgba(44, 56, 72, 0.8);
  height: 100vh;
  width: 100vw;
  padding-top: 15vh;
}
.modal-login {
  background-color: #284060;
  height: 400px;
  width: 30vw;
  border-radius: 40px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 120px 100px 180px;
  row-gap: 2%;
  justify-content: space-between;
  padding: 10px 15vh;
  position: relative;
}

.item--close {
  justify-self: end;
  position: absolute;
  right: 3%;
  width: 20px;
  height: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  top: 10px;
}
.item--close-icon {
  font-size: 11px;
  padding-top: 4.2px;
  padding-bottom: 3px;
}
.item--title {
  text-align: center;
  padding-top: 30px;
}
.form-login,
.area-btn-login,
.area--rrss {
  display: flex;
  flex-direction: column;
}

.area--rrss {
  min-height: 250px;
}
.area-input {
  position: relative;
}

.item--input {
  width: 100%;
  height: 40px;
  margin: 7px 0;
  background-color: #375072;
  border-radius: 15px;
  border: none;
  padding-left: 40px;
  box-sizing: border-box;
}
.item--input::placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.input--icon {
  position: absolute;
  left: 18px;
  right: 0;
  top: 18px;
  bottom: 0;
}
.item--forgot-password {
  text-align: center;
  margin: 7px 0;
  font-weight: 800;
}

.item--btn {
  margin: 7px 0;
  border: none;
  border-radius: 20px;
  color: white;
  font-family: Montserrat;
  cursor: pointer;
}
.item--register {
  text-align: center;
}
.btn-login {
  background-color: #94c659;
  font-size: 20px;
  font-weight: 600;
  height: 40px;
  width: 100%;
  margin: 10px auto;
}
.item--login {
  cursor: pointer;
}
@media (min-width: 1480px) {
  .modal-login {
    height: 50vh;
    width: 20vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .modal-login {
    /* height: 80vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .modal-login {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .modal-login {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .modal-login {
    /* height: 50vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .modal-login {
    height: 70vh;
    width: 65vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 8vh;
  }
}
@media (max-width: 600px) {
  .modal-login {
    /* height: 75vh; */
    width: 80vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 2vh;
  }

  .item--close {
    right: 3%;
    top: 6px;
  }
  .item--title {
    margin-top: 12px;
  }
}
</style>
